import traderapi from "../../traderapi/api";

class ReportDuplicateEmail {

    makeRecord(a) {
        return {
            name: a._id,
            count: a.count,
            items: a.ids
        }
    }
    //
    list(params, cb) {
        traderapi.getReportDuplicateEmail( (data) => {
            const items = data.map(this.makeRecord);
            cb({
                items,
                data,
            });
        }, params);
    }
}

export default ReportDuplicateEmail;